import { ReactNode } from 'react';

import { SideNavLayout } from 'components/layout/SideNavLayout';
import { TopNavLayout } from 'components/layout/TopNavLayout';
import { useHelpSidebar } from 'components/help_sidebar';
import { FormattedMessage, useIntl } from 'react-intl';
import { PageTitle } from 'utils/pageTitle';
import { Container } from 'react-bootstrap';
import { isEmbedded } from 'utils/other';
import cn from 'classnames';

export type DefaultLayoutProps = {
    children: ReactNode;
    pageTitle?: string
}

export const DefaultLayout = (props: DefaultLayoutProps) => {

    const { children, pageTitle } = props;
    const { visible } = useHelpSidebar();
    const { formatMessage } = useIntl();

    const resolvedPageTitle = pageTitle ?? formatMessage({ id: 'admin_portal.e2293887', defaultMessage: 'Admin Portal' });

    const containerClassName = cn(
        'py-3 py-md-5',
        { 'help-sidebar-open': visible }
    );

    // Embedded (iframe/modal) views hide the top + side nav so child reports look
    // clean and can't be used to navigate the app or run recursive reports.
    const embedded = isEmbedded();

    if (embedded) {

        return (
            <>
                <PageTitle title={`${resolvedPageTitle} | GMetrix`} />
                <Container as="main" className="py-3" id="pageContentContainer" tabIndex={-1}>
                    {children}
                </Container>
            </>
        );

    }

    return (
        <>
            <PageTitle title={`${resolvedPageTitle} | GMetrix`} />
            <a className="sr-only sr-only-focusable skip-to-content" href="#pageContentContainer">
                {<FormattedMessage defaultMessage="Skip to main content" id="skip_to_main_content.3a03f71d" />}
            </a>
            <SideNavLayout>
                <TopNavLayout className={containerClassName}>
                    <Container as="main" className={'flex-fill'} id={'pageContentContainer'} tabIndex={-1}>
                        {children}
                    </Container>
                </TopNavLayout>
            </SideNavLayout>
        </>
    );

};